
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import TitlePanel from '@/components/organisms/TitlePanel.vue'
import CompareLearningProgressPanel from '@/components/organisms/manage/CompareLearningProgressPanel.vue'
import { LearningProgressList } from '@/models/manage/LearningProgressList'
import { SelectItem } from '@/models/SelectItem'

/**
 * 通常学習進捗比較
 */
@Component({
  components: {
    ManageSidemenuLayout,
    TitlePanel,
    CompareLearningProgressPanel,
  },
})
export default class CompareLearningProgress extends Vue {
  /** 通常学習進捗比較パネル */
  @Ref()
  compareLearningProgressPanel!: CompareLearningProgressPanel

  /** 先生権限画面の場合true */
  @Prop({ default: false })
  private isTeacher!: boolean

  /** 塾管理者権限画面の場合true */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** 通常学習進捗集計データ一覧 */
  @Prop()
  private summaryProgressList!: LearningProgressList.Table[]

  /** 学年フィルターの選択肢 */
  @Prop()
  private filterGradeList!: SelectItem[]

  /** 学年フィルターの初期値 */
  @Prop()
  private defaultGradeCode!: string

  /** 教科フィルターの選択肢 */
  @Prop()
  private filterSubjectList!: SelectItem[]

  /** 教科フィルターの初期値 */
  @Prop()
  private defaultSubjectCode!: string

  /** 教材フィルターの選択肢 */
  @Prop()
  private filterStudyCategoryList!: SelectItem[]

  /** 教材フィルターのDisabled制御 */
  @Prop({ default: false })
  private isDisabledStudyCategoryFilter!: boolean

  /** コースフィルターの選択肢 */
  @Prop()
  private filterCourseList?: SelectItem[]

  /** コースフィルターのDisabled制御 */
  @Prop({ default: false })
  private isDisabledCourseFilter!: boolean

  /** 教室フィルターの選択肢 */
  @Prop()
  private filterBranchList?: SelectItem[]

  /** コースフィルターのDisabled制御 */
  @Prop({ default: false })
  private isDisabledBranchFilter!: boolean

  /** 教室タブの状態: trueならactive */
  @Prop({ default: false })
  private isBranchTabActive?: boolean

  /** コースタブの状態: trueならactive */
  @Prop({ default: false })
  private isCourseTabActive?: boolean

  /** クラスタブの状態: trueならactive */
  @Prop({ default: false })
  private isClassTabActive?: boolean

  /** 教室タブクリック時のイベント */
  @Prop()
  private eventClickBranchTab?: () => void

  /** コースタブクリック時のイベント */
  @Prop()
  private eventClickCourseTab?: () => void

  /** クラスタブクリック時のイベント */
  @Prop()
  private eventClickClassTab?: () => void

  /** 学年フィルター変更時のイベント */
  @Prop()
  private changeGradeFilter!: () => void

  /** 教科フィルター変更時のイベント */
  @Prop()
  private changeSubjectFilter!: () => void

  /** 教材フィルター変更時のイベント */
  @Prop()
  private changeStudyCategoryFilter!: () => void

  /** コースフィルター変更時のイベント */
  @Prop()
  private changeCourseFilter?: () => void

  /** 教室フィルター変更時のイベント */
  @Prop()
  private changeBranchFilter?: () => void

  /** ダウンロードボタン押下時のイベント */
  @Prop()
  private eventClickDownload!: () => void

  /**
   * 選択中の学年
   *
   * @returns 学年コード
   */
  public currentGrade(): string {
    return this.compareLearningProgressPanel.currentGrade()
  }

  /**
   * 選択中の教科
   *
   * @returns 教科コード
   */
  public currentSubject(): string {
    return this.compareLearningProgressPanel.currentSubject()
  }

  /**
   * 選択中の教材
   *
   * @returns 教材コード
   */
  public currentStudyCategory(): string {
    return this.compareLearningProgressPanel.currentStudyCategory()
  }

  /**
   * 教材フィルターの選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentStudyCategory(value: string): void {
    this.compareLearningProgressPanel.setCurrentStudyCategory(value)
  }

  /**
   * 選択中のコース
   *
   * @returns コースコード
   */
  public currentCourse(): string {
    return this.compareLearningProgressPanel.currentCourse()
  }

  /**
   * コースフィルターの選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentCourse(value: string): void {
    this.compareLearningProgressPanel.setCurrentCourse(value)
  }

  /**
   * 選択中の教室
   *
   * @returns 教室コード
   */
  public currentBranch(): string {
    return this.compareLearningProgressPanel.currentBranch()
  }

  /**
   * 教室フィルターの選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentBranch(value: string): void {
    this.compareLearningProgressPanel.setCurrentBranch(value)
  }
}
